import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import * as requestFromServer from "./faqsApis";

// faqs -> get faqs api
export const getFaqsAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.getFaqs(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_FAQS_LIST, {faqs:response}))
      return response;
    }
}


// faqs -> create faqs api
export const createFaqAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.createFaq(dataToBeSent);
    if (response) {
      toastService.success(response?.data?.message);
      return response;
    }
};


// faqs -> get faq by id api
export const getFaqByIdAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.getFaqById(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_FAQ_BY_ID,{faq:response}))
      return response;
    }
};


// faqs -> update faqs api
export const updateFaqAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.updateFaq(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      return response;
    }
};

// faqs -> delete faq by id api
export const deleteFaqByIdAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.deleteFaqById(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      return response;
    }
};